// @flow
// $FlowFixMe (see https://github.com/facebook/flow/pull/7111)
import React, { memo } from 'react';

import { messageFormat } from '@clubmed/utils';
import { pluralizeLabel } from 'Utils/label/labelUtils';

type Props = {
  pluralLabel: string,
  resultsCount: number,
  singularLabel: string,
};

export function SearchResultsTitle(props: Props) {
  const { singularLabel, pluralLabel, resultsCount } = props;

  if (!resultsCount || !singularLabel || !pluralLabel) {
    return null;
  }

  return (
    <h2 className="reset-heading font-brand font-bold leading-tight text-xl md:text-3xl">
      <span
        className="font-normal"
        dangerouslySetInnerHTML={{
          __html: messageFormat(pluralizeLabel(singularLabel, pluralLabel, resultsCount)).format({
            nbResults: `<strong class="text-blue">${resultsCount}</strong>`,
          }),
        }}
      />
    </h2>
  );
}

export default memo<Props>(SearchResultsTitle);
